import { MutationOptions, useMutation } from '@tanstack/react-query';

import { getTokensByAuthorizationCodeApi } from 'api/auth';
import { GetUserAuthTokensResponseDTO } from 'declarations/dto/auth';
import { RequestQueryKeysE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';

type useFetchUserAuthTokensParams = {
  onSuccess: MutationOptions<GetUserAuthTokensResponseDTO, ApiErrorI, string>['onSuccess'];
};

export const useFetchUserAuthTokens = ({ onSuccess }: useFetchUserAuthTokensParams) =>
  useMutation<GetUserAuthTokensResponseDTO, ApiErrorI, string>(
    [RequestQueryKeysE.FetchUserAuthTokens],
    getTokensByAuthorizationCodeApi,
    { onSuccess }
  );
